import { render, staticRenderFns } from "./CreditCardIcon.vue?vue&type=template&id=636b4dd7"
import script from "./CreditCardIcon.vue?vue&type=script&lang=js"
export * from "./CreditCardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports